/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { ConfirmFufuHotelReservationRequestInquiryResult } from './confirm-fufu-hotel-reservation-request-inquiry-result';

/**
 * 
 * @export
 * @interface ConfirmFufuHotelReservationRequest
 */
export interface ConfirmFufuHotelReservationRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfirmFufuHotelReservationRequest
     */
    'executionType': ConfirmFufuHotelReservationRequestExecutionTypeEnum;
    /**
     * 
     * @type {ConfirmFufuHotelReservationRequestInquiryResult}
     * @memberof ConfirmFufuHotelReservationRequest
     */
    'inquiryResult': ConfirmFufuHotelReservationRequestInquiryResult;
}

export const ConfirmFufuHotelReservationRequestExecutionTypeEnum = {
    execute: 'EXECUTE',
    test: 'TEST'
} as const;

export type ConfirmFufuHotelReservationRequestExecutionTypeEnum = typeof ConfirmFufuHotelReservationRequestExecutionTypeEnum[keyof typeof ConfirmFufuHotelReservationRequestExecutionTypeEnum];


